import { BehaviorSubject, Observable } from "rxjs";

export function createSubjectAndObservable<T>(initialValue: T): [BehaviorSubject<T>, Observable<T>] {
  const subject = new BehaviorSubject(initialValue);
  const observable = subject.asObservable();
  return [subject, observable];
}
